import EnumUserStatus from '../../../../../users/base/enums/EnumUserStatus';
import PageRequest from '../../../../../pagination-helper/lib/PageRequest';

/**
 * * Запос на получение списка пользователей для владельца
 */
export default class OwnedUsersRequest  {
	/**
	 * * Поиск
	 */
	Search!: string;
	/**
	 * * Фильтрация по списку статусов
	 */
	StatusList!: Array<EnumUserStatus>;
	/**
	 * * Постраничка
	 */
	Page!: PageRequest;
	constructor(obj?: Partial<OwnedUsersRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
